import { Form, InputNumber, Switch, theme, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

export default function Fee() {
	const isPaymentAvailable = !!import.meta.env.VITE_APP_VERITRANS_POP_CLIENT_KEY;
	const colorPrimary = theme.useToken().token.colorPrimary;

	return (
		<div className="flex gap-x-4 items-center h-8">
			<span>有料イベント設定</span>

			<Tooltip
				overlayInnerStyle={{ width: 260 }}
				title={
					<div>
						<div>有料イベント設定を行うには、</div>
						<div>決済代行会社との契約後が必要です。</div>
					</div>
				}
			>
				<QuestionCircleOutlined
					style={{ color: colorPrimary }}
					className="-ml-2 mr-1"
				/>
			</Tooltip>

			<Form.Item
				noStyle
				shouldUpdate={(prevValues, currentValues) =>
					prevValues.fee !== currentValues.fee
				}
			>
				{({ getFieldValue, setFieldValue }) => {
					const fee = parseFloat(getFieldValue("fee"));

					return (
						<>
							<Form.Item
								noStyle
								name="fee"
								valuePropName="checked"
								className="mb-0"
								getValueProps={() => {
									return {
										value: !!fee,
									};
								}}
							>
								<Switch
									disabled={!isPaymentAvailable}
									onChange={(value) => {
										setFieldValue("fee", value ? 1 : 0);
									}}
								/>
							</Form.Item>

							{fee ? (
								<div className="flex items-center">
									<Form.Item
										noStyle
										name="fee"
										getValueProps={() => {
											return {
												value: parseFloat(fee),
											};
										}}
									>
										<InputNumber
											size="middle"
											value={fee}
											style={{ width: 150 }}
										/>
									</Form.Item>
									<span className="ml-2">円</span>
								</div>
							) : null}
						</>
					);
				}}
			</Form.Item>
		</div>
	);
}
